// Live sanitizer for landlord-facing decimal price/area inputs.
//
// Keeps only digits plus at most ONE decimal separator (comma OR dot), allows a
// temporary trailing separator while typing ("1223," / "1223."), and caps the
// fractional part at 2 digits. Strips letters, spaces, units, exponent (e/E),
// signs (+/-), and any extra separators/fraction digits.
//
// It does NOT enforce the money/size cap — that stays on blur/submit + backend,
// so a user can keep typing the integer part freely while typing.
export function filterDecimalInput(value) {
  var v = String(value == null ? '' : value).replace(/[^\d.,]/g, '');
  var sepIndex = v.search(/[.,]/);
  if (sepIndex === -1) {
    return v;
  }
  var sepChar = v.charAt(sepIndex);
  var intPart = v.slice(0, sepIndex).replace(/[.,]/g, '');
  var fracPart = v.slice(sepIndex + 1).replace(/[.,]/g, '').slice(0, 2);
  return intPart + sepChar + fracPart;
}

// Live sanitizer for landlord-facing integer-only fields (Scope C): keeps digits
// only, stripping comma, dot, letters, spaces, exponent (e/E), signs (+/-) and
// units. Empty optional value is preserved. No cap is enforced here (that stays
// on blur/submit + backend).
export function filterIntegerInput(value) {
  return String(value == null ? '' : value).replace(/[^\d]/g, '');
}

export default filterDecimalInput;
